/**
 * チャンクメッセージ処理用ユーティリティ関数
 */

/**
 * Base64文字列をUint8Arrayに変換
 */
export function base64ToUint8(base64: string): Uint8Array {
    const bin = atob(base64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) arr[i] = bin.charCodeAt(i);
    return arr;
}

/**
 * gzip圧縮されたUint8ArrayをDecompressionStreamで解凍しutf8文字列に変換
 */
export async function ungzipUint8Array(uint8: Uint8Array): Promise<string> {
    const DS = (window as any).DecompressionStream;
    if (typeof DS !== 'function') {
        throw new Error('DecompressionStream is not supported in this browser');
    }

    const ds = new DS('gzip');
    const response = new Response(uint8.buffer as ArrayBuffer);
    const body = response.body;

    if (!body) {
        throw new Error('Failed to get response body for decompression');
    }

    const stream = body.pipeThrough(ds);
    const decompressed = await new Response(stream).arrayBuffer();
    const decoder = new TextDecoder('utf-8');

    return decoder.decode(decompressed);
}

/**
 * 複数のチャンクデータ（base64）を結合してデコードし、JSON文字列として返す
 * 
 * @param chunks base64エンコードされたチャンクデータの配列（順序正しく並んでいること）
 * @returns 結合・解凍されたJSON文字列
 */
export async function restoreChunkedData(chunks: string[]): Promise<string> {
    // base64デコード→Uint8Array結合
    const bufs = chunks.map(chunk => base64ToUint8(chunk));
    const totalLen = bufs.reduce((sum, b) => sum + b.length, 0);
    const all = new Uint8Array(totalLen);

    let offset = 0;
    for (const b of bufs) {
        all.set(b, offset);
        offset += b.length;
    }

    // DecompressionStreamでgzip解凍
    const utf8str = await ungzipUint8Array(all);

    return utf8str;
}
